export default {
  props: ["icon"],
};
